/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NameDisplayOption = {
    Full: 'FULL',
    Initial: 'INITIAL'
} as const;
export type NameDisplayOption = typeof NameDisplayOption[keyof typeof NameDisplayOption];


export function instanceOfNameDisplayOption(value: any): boolean {
    for (const key in NameDisplayOption) {
        if (Object.prototype.hasOwnProperty.call(NameDisplayOption, key)) {
            // @ts-ignore
            if (NameDisplayOption[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NameDisplayOptionFromJSON(json: any): NameDisplayOption {
    return NameDisplayOptionFromJSONTyped(json, false);
}

export function NameDisplayOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NameDisplayOption {
    return json as NameDisplayOption;
}

export function NameDisplayOptionToJSON(value?: NameDisplayOption | null): any {
    return value as any;
}

